import { Group, Text } from "@mantine/core";

import type { JSX } from "react";

// TODO:// @grahammatt suggestion - https://alpha.mantine.dev/dates/time-value/ (mantine v8 is currently in beta)
export const ElapsedTimeValue = ({
    value,
    unit,
    size = "sm",
    visibleFrom,
}: {
    value: string;
    unit: string;
    size?: string;
    visibleFrom?: string;
}): JSX.Element => {
    return (
        <Group gap="3xs" wrap="nowrap" visibleFrom={visibleFrom}>
            <Text span size={size} ff="mono">
                {value}
            </Text>
            <Text span size={size}>
                {unit}
            </Text>
        </Group>
    );
};
